import { useStyletron } from 'baseui';
import { ParagraphXSmall } from 'baseui/typography';
import { NumberFormatOptionsStyle, default as ValueDisplay } from './ValueDisplay'
import { Block } from 'baseui/block';


export type ValueDisplayWithLabelProps = {
    value: number | boolean| string,
    dimension?: string,
    small?: boolean,
    mini?: boolean,
    label: any,
    alignSelf?: any
    color?: string,
    style?: NumberFormatOptionsStyle | undefined,
    currencyCode?: string
}

const ValueDisplayWithLabel = (props: ValueDisplayWithLabelProps) => {
    const [css, theme] = useStyletron();
    return (
        <Block flexDirection='row' alignItems='baseline' display='flex' gridGap='0.5em'  alignSelf={props.alignSelf}>
            <ParagraphXSmall margin={0} color={theme.colors.primary500}>{props.label} </ParagraphXSmall>
            <ValueDisplay {...props}></ValueDisplay>
        </Block>
    )
}


export default ValueDisplayWithLabel;